module.exports = __webpack_public_path__ + "media/images/discover-db11c96e8d46901e56d80520c46e9a6a.png";